import {
  GET_ACCOUNT_INTEGRATIONS_V2,
  GET_ACCOUNT_INTEGRATIONS_V2_SUCCESS,
  GET_ACCOUNT_INTEGRATIONS_V2_ERROR,
  GET_TEMPLATE_INTEGRATIONS_V2,
  GET_TEMPLATE_INTEGRATIONS_V2_SUCCESS,
  GET_TEMPLATE_INTEGRATIONS_V2_ERROR,
  GET_CAMPAIGN_ELIGIBLE_INTEGRATIONS_V2,
  GET_CAMPAIGN_ELIGIBLE_INTEGRATIONS_V2_SUCCESS,
  GET_CAMPAIGN_ELIGIBLE_INTEGRATIONS_V2_ERROR,
  GET_CAMPAIGN_ATTACHED_INTEGRATIONS_V2,
  GET_CAMPAIGN_ATTACHED_INTEGRATIONS_V2_SUCCESS,
  GET_CAMPAIGN_ATTACHED_INTEGRATIONS_V2_ERROR,
  GET_LEAD_INTEGRATION_DETAILS_V2,
  GET_LEAD_INTEGRATION_DETAILS_V2_SUCCESS,
  GET_LEAD_INTEGRATION_DETAILS_V2_ERROR,
  DUPLICATE_INTEGRATION_V2,
  DUPLICATE_INTEGRATION_V2_SUCCESS,
  DUPLICATE_INTEGRATION_V2_ERROR,
  DELETE_INTEGRATION_V2,
  DELETE_INTEGRATION_V2_SUCCESS,
  DELETE_INTEGRATION_V2_ERROR,
} from "./actionTypes"

export const getAccountIntegrationsV2 = () => ({
  type: GET_ACCOUNT_INTEGRATIONS_V2,
})

export const getAccountIntegrationsV2Success = (integrations) => ({
  type: GET_ACCOUNT_INTEGRATIONS_V2_SUCCESS,
  payload: integrations,
})

export const getAccountIntegrationsV2Error = (error) => ({
  type: GET_ACCOUNT_INTEGRATIONS_V2_ERROR,
  payload: error,
})

export const getTemplateIntegrationsV2 = () => ({
  type: GET_TEMPLATE_INTEGRATIONS_V2,
})

export const getTemplateIntegrationsV2Success = (integrations) => ({
  type: GET_TEMPLATE_INTEGRATIONS_V2_SUCCESS,
  payload: integrations,
})

export const getTemplateIntegrationsV2Error = (error) => ({
  type: GET_TEMPLATE_INTEGRATIONS_V2_ERROR,
  payload: error,
})

export const getCampaignEligibleIntegrationsV2 = () => ({
  type: GET_CAMPAIGN_ELIGIBLE_INTEGRATIONS_V2,
})

export const getCampaignEligibleIntegrationsV2Success = (integrations) => ({
  type: GET_CAMPAIGN_ELIGIBLE_INTEGRATIONS_V2_SUCCESS,
  payload: integrations,
})

export const getCampaignEligibleIntegrationsV2Error = (error) => ({
  type: GET_CAMPAIGN_ELIGIBLE_INTEGRATIONS_V2_ERROR,
  payload: error,
})

export const getCampaignAttachedIntegrationsV2 = ({ campaign_id } = {}) => ({
  type: GET_CAMPAIGN_ATTACHED_INTEGRATIONS_V2,
  payload: { campaign_id },
})

export const getCampaignAttachedIntegrationsV2Success = (integrations) => ({
  type: GET_CAMPAIGN_ATTACHED_INTEGRATIONS_V2_SUCCESS,
  payload: integrations,
})

export const getCampaignAttachedIntegrationsV2Error = (error) => ({
  type: GET_CAMPAIGN_ATTACHED_INTEGRATIONS_V2_ERROR,
  payload: error,
})

export const getLeadIntegrationDetailsV2 = (integration_id) => ({
  type: GET_LEAD_INTEGRATION_DETAILS_V2,
  payload: { integration_id },
})

export const getLeadIntegrationDetailsV2Success = (integration) => ({
  type: GET_LEAD_INTEGRATION_DETAILS_V2_SUCCESS,
  payload: integration,
})

export const getLeadIntegrationDetailsV2Error = (error) => ({
  type: GET_LEAD_INTEGRATION_DETAILS_V2_ERROR,
  payload: error,
})

export const duplicateIntegrationV2 = ({ id, is_template }) => ({
  type: DUPLICATE_INTEGRATION_V2,
  payload: { id, is_template },
})

export const duplicateIntegrationV2Success = ({ integration, is_template }) => ({
  type: DUPLICATE_INTEGRATION_V2_SUCCESS,
  payload: { integration, is_template },
})

export const duplicateIntegrationV2Error = ({ error, is_template }) => ({
  type: DUPLICATE_INTEGRATION_V2_ERROR,
  payload: { error, is_template },
})

export const deleteIntegrationV2 = ({ id, is_template }) => ({
  type: DELETE_INTEGRATION_V2,
  payload: { id, is_template },
})

export const deleteIntegrationV2Success = ({ integration, is_template }) => ({
  type: DELETE_INTEGRATION_V2_SUCCESS,
  payload: { integration, is_template },
})

export const deleteIntegrationV2Error = ({ error, is_template }) => ({
  type: DELETE_INTEGRATION_V2_ERROR,
  payload: { error, is_template },
})
